module.exports = {
      id: "hamburger-instagram-usage",
      viewBox: "0 0 38 37",
      url: __webpack_public_path__ + "svg-sprite-ef426a51ffa8e0d9106d678bb4289730.svg#hamburger-instagram",
      toString: function () {
        return this.url;
      }
    }